import React from 'react';
import { Card } from 'antd';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './styles.scss';

const MyCard = ({
  className,
  children,
  title,
  extra,
  actions,
  bordered = true,
  size = 'default',
  hoverable = false,
  loading = false,
  cover,
  bodyStyle,
  headStyle,
  ...rest
}) => {
  return (
    <Card
      className={classnames('my-card', className)}
      title={title}
      extra={extra}
      actions={actions}
      bordered={bordered}
      size={size}
      hoverable={hoverable}
      loading={loading}
      cover={cover}
      bodyStyle={bodyStyle}
      headStyle={headStyle}
      {...rest}
    >
      <div className="my-card-body">{children}</div>
    </Card>
  );
};

MyCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.node,
  extra: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
  bordered: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
  hoverable: PropTypes.bool,
  loading: PropTypes.bool,
  cover: PropTypes.node,
  bodyStyle: PropTypes.object,
  headStyle: PropTypes.object,
};

export default MyCard;
